import type {
    ActivationAlertsContractSocialMediaMetricsDataPoint,
    ActivationAlertsContractSocialMediaMetricsDomainData,
} from "@similarweb/pro-api-client";

import type { Series } from "../../common/widget/line-graph/types";
import type { SocialMetricsDataType } from "../types";
import { movePrimaryItemToStart } from "../../common/utils/movePrimaryItemToStart";

const getSeries = (dataPoints: ActivationAlertsContractSocialMediaMetricsDataPoint[]) => {
    const result: Record<SocialMetricsDataType, Series> = {
        comments: [],
        reactions: [],
        shares: [],
        views: [],
        totalPosts: [],
        audienceSize: [],
    };

    dataPoints.forEach(({ startDate, comments, reactions, shares, views, totalPosts, audienceSize }) => {
        const x = startDate;

        result.comments.push({ x, y: comments });
        result.reactions.push({ x, y: reactions });
        result.shares.push({ x, y: shares });
        result.views.push({ x, y: views });
        result.totalPosts.push({ x, y: totalPosts });
        result.audienceSize.push({ x, y: audienceSize });
    });

    return result;
};

type TransformSocialMediaMetricsOverTimeDataParams = {
    data: ActivationAlertsContractSocialMediaMetricsDomainData[];
    primaryDomain?: string;
};

export const transformSocialMediaMetricsOverTimeData = ({
    primaryDomain,
    data,
}: TransformSocialMediaMetricsOverTimeDataParams) => {
    const sortedData = primaryDomain ? movePrimaryItemToStart(primaryDomain, data) : data;

    return sortedData.map(({ dataPoints, domain, totalVolume }) => {
        const series = getSeries(dataPoints);

        return {
            domain,
            series,
            totalVolume,
        };
    });
};
